import { FC, ReactNode } from "react";

import { IWrapper } from "@/app/application/WrapperCenter";

interface IWrapperLeft extends IWrapper {
	children: ReactNode;
}

export const WrapperLeft: FC<IWrapperLeft> = (props) => {
	const className = `wrapper-left ${props.className ? props.className : ""}`;
	return <section className={className}>{props.children}</section>;
};
